module.exports = __webpack_public_path__ + "static/MVP-cb4f833a6f7c1b92f46675e690e7c23f.png";